import { useEffect, useState } from "react";
import verificationImage from "../../assests/page/verify-kyc.svg";
import SumsubWebSdk from "@sumsub/websdk-react";
import { errorToast, KYCTexts } from "../../utils/constants";
import { chainDetails } from "../../utils/config";
import SuccessPopup from "./success";
import { useWalletSelector } from "@near-wallet-selector/react-hook";
import { VerifiedWallet } from "@verified-network/verified-sdk";
import KYCQuestionnaire from "./questionnaire";
import { hashTheString } from "@verified-network/verified-custody";
import {
  createAccessTokenForNewUser,
  fetchUserDetailsFromSumsub,
  fixApplicantRejections,
} from "../../utils/helpers/kyc";
import {
  hexTrustVaultAddress,
  hexTrustVaults,
} from "../../utils/helpers/hextrust";
import {
  decryptUserKycData,
  saveUserKycQuestionaire,
} from "../../utils/helpers/utils";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import { useNavigate } from "react-router-dom";
import { useConnector } from "@solana-commerce/connector";

const VerifyKYC = (props) => {
  const [tokenToUse, setTokenToUse] = useState(
    props?.additionalProps?.accessToken,
  );
  const [showSumsubPortal, setShowSumsubPortal] = useState(
    props.showPortal || false,
  );
  const [kycCompleted, setKycCompleted] = useState(props.kycCompleted || false);
  const [kycError, setKycError] = useState(props.kycError || false);
  const [showRejectionText, setShowRejectionText] = useState(false);
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [newApplicantId, setNewApplicantId] = useState("");
  const [linkToUse, setLinkToUse] = useState("");
  const [decryptedQuestionaire, setDecryptedQuestionaire] = useState({});
  const { signedAccountId } = useWalletSelector();
  const { accounts } = useConnector();

  const { chainId, signer, name, provider } = useNetworkStore();
  const { userAddress, accessToken } = useUserStore();

  const navigate = useNavigate();

  const { allCountries, setKycQuestionaire, pendingQuestionaire } =
    props.generalDataProps;

  useEffect(() => {
    const generateNewAccessToken = async () => {
      if (accessToken?.length === 0) {
        const accessTokenRes = await createAccessTokenForNewUser(
          signedAccountId?.length > 0
            ? VerifiedWallet.createWallet()?.address
            : accounts[0]?.address?.length > 0
              ? VerifiedWallet.createWallet()?.address
              : props?.additionalProps?.userAddress,
          signedAccountId?.length > 0
            ? `397-${signedAccountId}`
            : accounts[0]?.address?.length > 0
              ? `397-${accounts[0]?.address}`
              : props?.additionalProps?.chainId,
          props.additionalProps?.isOtp ? true : null,
        );

        setTokenToUse(accessTokenRes?.accessToken);
      } else {
        setTokenToUse(accessToken);
      }
    };
    if (
      !props?.additionalProps?.accessToken ||
      props?.additionalProps?.accessToken === ""
    ) {
      generateNewAccessToken();
    }
  }, [
    accessToken,
    accounts,
    props.additionalProps?.accessToken,
    props.additionalProps?.chainId,
    props.additionalProps?.isOtp,
    props.additionalProps?.userAddress,
    signedAccountId,
  ]);

  useEffect(() => {
    const handleOtpComplete = async () => {
      if (props.mobileScreen && props.generalDataProps?.setPageAction) {
        props.generalDataProps.setPageAction("Authentication");
      }
      props.setPopupContentPosition("center");
      props.setPopupContent(props.additionalProps.nextPopup);

      props.setShowPopup(true);

      await fetchUserDetailsFromSumsub(newApplicantId).then(async (res) => {
        if (res?.phone && res?.email) {
          const displayName = `${res?.email?.toLowerCase()}-${res?.phone?.toLowerCase()}`;

          if (props.custodyId?.toLowerCase() === "hextrust") {
            const allVaults = await hexTrustVaults(
              chainDetails[0]?.chainId,
              res?.email?.toLowerCase(),
              res?.phone?.toLowerCase()?.replace("+", ""),
            );

            if (allVaults?.length > 1) {
              errorToast(
                "Unexpected Error!",
                "More than one HexTrust account linked to users.",
              );
              props.setShowPopup(false);
              if (props.generalDataProps?.setPageAction) {
                props.generalDataProps.setPageAction("");
              }
              props.setPopupContentPosition("center");
              props.setPopupContent(null);
            } else if (allVaults?.length === 1) {
              if (
                props.generalDataProps?.setCustodyWalletDetails &&
                allVaults[0]?.id
              ) {
                const addresses = await hexTrustVaultAddress(
                  allVaults[0]?.id,
                  chainDetails[0]?.chainId,
                );
                if (addresses?.length > 0) {
                  if (
                    addresses?.find(
                      (add) =>
                        Number(add?.chainId) === chainDetails[0]?.chainId,
                    )?.address
                  ) {
                    props.generalDataProps.setCustodyWalletDetails({
                      custodyId: props.custodyId?.toLowerCase(),
                      vaultId: allVaults[0]?.id,
                      address: addresses?.find(
                        (add) =>
                          Number(add?.chainId) === chainDetails[0]?.chainId,
                      )?.address,
                      pk: props.additionalProps?.userPk,
                      chainId: chainDetails[0]?.chainId,
                    });
                    localStorage.setItem(
                      "vHexT",
                      JSON.stringify({
                        displayName,
                        custodyId: props.custodyId?.toLowerCase(),
                        vaultId: allVaults[0]?.id,
                        address: addresses?.find(
                          (add) =>
                            Number(add?.chainId) === chainDetails[0]?.chainId,
                        )?.address,
                        pk: props.additionalProps?.userPk,
                        chainId: chainDetails[0]?.chainId,
                      }),
                    );
                    props.setPopupContentPosition("center");
                    props.setPopupContent(
                      <div
                        style={{ display: "unset" }}
                        className="verify-kyc-popup"
                      >
                        <SuccessPopup
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully connected your hexTrust account`}
                          setFavouriteClicked={props.setFavouriteClicked}
                          customWidth="100"
                        />
                      </div>,
                    );

                    props.setShowPopup(true);
                  } else {
                    props.generalDataProps.setCustodyWalletDetails({
                      custodyId: props.custodyId?.toLowerCase(),
                      vaultId: allVaults[0]?.id,
                      address: addresses[0]?.address,
                      pk: props.additionalProps?.userPk,
                      chainId: addresses[0]?.chainId,
                    });
                    localStorage.setItem(
                      "vHexT",
                      JSON.stringify({
                        displayName,
                        custodyId: props.custodyId?.toLowerCase(),
                        vaultId: allVaults[0]?.id,
                        address: addresses[0]?.address,
                        pk: props.additionalProps?.userPk,
                        chainId: addresses[0]?.chainId,
                      }),
                    );
                    props.setPopupContentPosition("center");
                    props.setPopupContent(
                      <div
                        style={{ display: "unset" }}
                        className="verify-kyc-popup"
                      >
                        <SuccessPopup
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          isCustom={true}
                          customTextHeader="Congratulations!"
                          customTextFooter={`You have successfully connected your hexTrust account`}
                          setFavouriteClicked={props.setFavouriteClicked}
                          customWidth="100"
                        />
                      </div>,
                    );

                    props.setShowPopup(true);
                  }
                } else {
                  errorToast(
                    "Unexpected Error!",
                    "Error while fetching HexTrust account wallets. Try again later",
                  );
                }
              } else {
                errorToast(
                  "Unexpected Error!",
                  "Error while fetching HexTrust account wallets. Try again later",
                );
              }
            } else {
              const hexActive = JSON.parse(localStorage.getItem("vHexT"));
              if (
                hexActive?.displayName?.toLowerCase() ===
                displayName?.toLowerCase()
              ) {
                errorToast(
                  "HexTrust Account Pending",
                  "You have a pending HexTrust account, wait till you hear back from us.",
                );
                props.setShowPopup(false);
                if (props.generalDataProps?.setPageAction) {
                  props.generalDataProps.setPageAction("");
                }
                props.setPopupContentPosition("center");
                props.setPopupContent(null);
              } else {
                await createAccessTokenForNewUser(
                  props.additionalProps.userAddress,
                  0,
                ).then((res) => {
                  if (res?.accessToken) {
                    props.setPopupContentPosition("center");
                    props.setPopupContent(
                      <VerifyKYC
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        buttonAction={"verify-kyc"}
                        showPortal={true}
                        additionalProps={{
                          accessToken: res?.accessToken,
                          userAddress: props.userAddress,
                          chainId: 0,
                        }}
                        custodyId="hextrust"
                        generalDataProps={props.generalDataProps}
                      />,
                    );
                    props.setShowPopup(true);
                  } else {
                    errorToast(
                      "Unexpected Error!",
                      "Error initiating KYC process. Try again later",
                    );
                  }
                });
              }
            }
          }
        } else {
          errorToast("Unexpected Error!", "Error fetching user's details");
          props.setShowPopup(false);
          if (props.generalDataProps?.setPageAction) {
            props.generalDataProps.setPageAction("");
          }
          props.setPopupContentPosition("center");
          props.setPopupContent(null);
        }
      });
    };

    if (props.additionalProps.isOtp && kycCompleted && newApplicantId) {
      handleOtpComplete();
    }
  }, [kycCompleted, newApplicantId, props]);

  const sumsubConfig = {
    lang: "en",
    theme: "light",
    i18n: {
      document: {
        subTitles: {
          IDENTITY: "Upload a document that proves your identity",
        },
      },
    },
  };

  return (
    <div
      style={{ display: "unset", marginBottom: "50px" }}
      className="verify-kyc-popup"
    >
      {!showSumsubPortal && (
        <img
          alt="KYC Verification"
          src={verificationImage}
          className="verify-kyc-image"
        />
      )}

      {!showSumsubPortal && (
        <div className="verify-kyc-content">
          <p className="verify-kyc-header-text">KYC Incomplete</p>
          {Object.keys(pendingQuestionaire)?.length === 0 && (
            <p className="verify-kyc-footer-text">
              KYC not completed, Please complete your KYC to activate your
              wallet.
            </p>
          )}
          {Object.keys(pendingQuestionaire)?.length > 0 && (
            <p className="verify-kyc-footer-text">
              You have a pending KYC application. Please click “Resume KYC” and
              sign the message in your wallet to continue from where you left
              off.
            </p>
          )}
        </div>
      )}

      {showSumsubPortal && (
        <>
          {kycCompleted && !props.additionalProps.isOtp && (
            <div className="verify-kyc-content">
              <p
                style={{
                  wordWrap: "break-word",
                  width: "400px",
                }}
                className="verify-kyc-header-text"
              >
                {KYCTexts.kycSubmitted}
              </p>
              {props.additionalProps?.chainId === 0 ? (
                <p
                  style={{ width: "400px" }}
                  className="verify-kyc-footer-text"
                >
                  {KYCTexts.waitForEmailCustody}
                </p>
              ) : (
                <>
                  <p
                    style={{ width: "400px" }}
                    className="verify-kyc-footer-text"
                  >
                    {KYCTexts.waitForEmail}
                  </p>

                  {showRejectionText && rejectionMessage?.length > 0 && (
                    <p
                      style={{
                        width: "400px",
                        color: "red",
                        marginTop: "5px",
                        marginBottom: "2px",
                      }}
                      className="verify-kyc-footer-text"
                    >
                      {rejectionMessage?.replace(
                        "If you have any questions, contact the company you're verifying with compliance@verified.network",
                        "Please click on 'Fix Rejection' to update and resubmit your profile.",
                      )}
                    </p>
                  )}
                </>
              )}
            </div>
          )}

          {kycError && (
            <div className="verify-kyc-content">
              <p className="verify-kyc-header-text">Unexpected Error!</p>
            </div>
          )}

          {!kycCompleted && !kycError && tokenToUse?.length > 0 && (
            <SumsubWebSdk
              accessToken={tokenToUse}
              expirationHandler={async () => {
                Promise.resolve(
                  await createAccessTokenForNewUser(
                    props.additionalProps.userAddress,
                    props.additionalProps.chainId,
                    props.additionalProps?.isOtp ? true : null,
                  ).then((res) => {
                    return res?.accessToken;
                  }),
                );
              }}
              config={sumsubConfig}
              options={{ addViewportTag: true, adaptIframeHeight: true }}
              onMessage={async (msg, payload) => {
                if (
                  msg === "idCheck.applicantStatus"
                  // payload?.reviewResult?.reviewAnswer?.toLowerCase() === "red"
                ) {
                  // setKycCompleted(true);

                  props.setPopupContentPosition("center");
                  props.setPopupContent(
                    <KYCQuestionnaire
                      countryList={Object.values(allCountries)}
                      generalDataProps={props.generalDataProps}
                      hashedUserAddress={hashTheString(
                        props?.additionalProps?.userAddress,
                      )}
                      hashedUserId={hashTheString("")}
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setCustomLoading={props.setCustomLoading}
                      additionalProps={props.additionalProps}
                      KYCQuestionnaire={decryptedQuestionaire}
                    />,
                  );
                  props.setShowPopup(true);

                  if (props.additionalProps?.isHexInit) {
                    await fetchUserDetailsFromSumsub(newApplicantId).then(
                      async (res) => {
                        if (res?.phone && res?.email) {
                          const displayName = `${res?.email?.toLowerCase()}-${res?.phone?.toLowerCase()}`;
                          if (props.custodyId?.toLowerCase() === "hextrust") {
                            localStorage.setItem(
                              "vHexT",
                              JSON.stringify({ displayName }),
                            );
                          }
                        }
                      },
                    );
                  }
                } else if (msg === "idCheck.onApplicantLoaded") {
                  const applicantId = payload?.applicantId;
                  setNewApplicantId(applicantId);
                } else if (msg === "idCheck.onApplicantSubmitted") {
                  // setKycCompleted(true);
                  props.setPopupContentPosition("center");
                  props.setPopupContent(
                    <KYCQuestionnaire
                      countryList={Object.values(allCountries)}
                      generalDataProps={props.generalDataProps}
                      hashedUserAddress={hashTheString(
                        props?.additionalProps?.userAddress,
                      )}
                      hashedUserId={hashTheString("")}
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setCustomLoading={props.setCustomLoading}
                      additionalProps={props.additionalProps}
                      KYCQuestionnaire={decryptedQuestionaire}
                    />,
                  );
                  props.setShowPopup(true);
                } else if (payload?.reviewResult?.reviewAnswer?.length > 0) {
                  props.setPopupContentPosition("center");
                  props.setPopupContent(
                    <KYCQuestionnaire
                      countryList={Object.values(allCountries)}
                      generalDataProps={props.generalDataProps}
                      hashedUserAddress={hashTheString(
                        props?.additionalProps?.userAddress,
                      )}
                      hashedUserId={hashTheString("")}
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setCustomLoading={props.setCustomLoading}
                      additionalProps={props.additionalProps}
                      KYCQuestionnaire={decryptedQuestionaire}
                    />,
                  );
                  props.setShowPopup(true);
                  // setKycCompleted(true);

                  // if (Number(kycRes?.userKycStatus) !== 3) {
                  //   //always verify user is not approved before show rejections
                  //   if (
                  //     payload?.reviewResult?.reviewAnswer?.toLowerCase() ===
                  //       "red" &&
                  //     payload?.reviewResult?.reviewRejectType?.toLowerCase() ===
                  //       "final"
                  //   ) {
                  //     setRejectionMessage(
                  //       payload?.reviewResult?.moderationComment?.length > 0
                  //         ? payload?.reviewResult?.moderationComment
                  //         : KYCTexts.underReview
                  //     );
                  //   }
                  //   if (
                  //     payload?.reviewResult?.reviewAnswer?.toLowerCase() ===
                  //       "red" &&
                  //     payload?.reviewResult?.reviewRejectType?.toLowerCase() !==
                  //       "final"
                  //   ) {
                  //     setRejectionMessage(
                  //       payload?.reviewResult?.moderationComment?.length > 0
                  //         ? payload?.reviewResult?.moderationComment
                  //         : KYCTexts.resubmission
                  //     );
                  //   }
                  // }
                }
              }}
              onError={(data) => {
                setKycError(true);
              }}
            />
          )}

          {!kycCompleted && !kycError && linkToUse?.length > 0 && (
            <iframe
              title="KYC Resubmission"
              src={linkToUse}
              width="100%"
              height="550px"
            ></iframe>
          )}
        </>
      )}

      <div
        style={{ marginBottom: "0", marginTop: "10px" }}
        className="verify-kyc-buttons"
      >
        {!showSumsubPortal && (
          <>
            <button
              onClick={() => {
                props.setShowPopup(false);
                props.setPopupContent(null);
                if (props.setPopupContentPosition) {
                  props.setPopupContentPosition("center");
                }
                if (props.setFavouriteClicked) {
                  props.setFavouriteClicked(false);
                }
              }}
              className="verify-kyc-button-back"
            >
              <p className="verify-kyc-button-back-text">Back</p>
            </button>
            {Object.keys(pendingQuestionaire)?.length > 0 && (
              <button
                onClick={async () => {
                  try {
                    props.setCustomLoading(true);
                    //save DB questionaire first
                    if (
                      !pendingQuestionaire?.shouldSave ||
                      !pendingQuestionaire?.shouldSave?.notSave
                    ) {
                      console.log("Pending is local will save first");
                      const { saved, signature, nonce, nearNonce } =
                        await saveUserKycQuestionaire(
                          userAddress,
                          chainId,
                          name,
                          signer,
                          provider,
                          pendingQuestionaire,
                          hashTheString(userAddress),
                          false,
                          true,
                        );
                      if (saved) {
                        const userQuestionaire = await decryptUserKycData(
                          userAddress,
                          chainId,
                          name,
                          signer,
                          signature,
                          nonce,
                          nearNonce,
                        );

                        setKycQuestionaire(userQuestionaire || {});
                        setDecryptedQuestionaire(userQuestionaire || {});
                        setShowSumsubPortal(true);
                      }
                    } else {
                      console.log("Pending is DB will just decrypt");
                      //skip save and decrypt if pending questionaire is from DB
                      const userQuestionaire = await decryptUserKycData(
                        userAddress,
                        chainId,
                        name,
                        signer,
                      );

                      setKycQuestionaire(userQuestionaire || {});
                      setDecryptedQuestionaire(userQuestionaire || {});

                      setShowSumsubPortal(true);
                    }

                    props.setCustomLoading(false);
                  } catch (err) {
                    props.setCustomLoading(false);
                  }
                }}
                className="verify-kyc-button"
              >
                <p className="verify-kyc-button-text">Resume KYC</p>
              </button>
            )}
            {Object.keys(pendingQuestionaire)?.length === 0 && (
              <button
                onClick={() => {
                  setShowSumsubPortal(true);
                }}
                className="verify-kyc-button"
              >
                <p className="verify-kyc-button-text">Complete KYC</p>
              </button>
            )}
          </>
        )}
        {showSumsubPortal && kycCompleted && !kycError && (
          <>
            {rejectionMessage?.length > 0 && (
              <>
                {!showRejectionText && (
                  <button
                    onClick={() => {
                      if (rejectionMessage?.length > 0) {
                        setShowRejectionText(true);
                      }
                    }}
                    className="verify-kyc-button-back"
                  >
                    <p className="verify-kyc-button-back-text">
                      Check Rejection
                    </p>
                  </button>
                )}
                {showRejectionText && (
                  <button
                    onClick={async () => {
                      if (rejectionMessage?.length > 0 && newApplicantId) {
                        props.setCustomLoading(true);
                        const oldDetails =
                          await fetchUserDetailsFromSumsub(newApplicantId);
                        const link = await fixApplicantRejections(
                          newApplicantId,
                          oldDetails?.externalUserId,
                        );
                        if (link?.length > 0) {
                          setLinkToUse(link);
                          setTokenToUse("");
                          setShowRejectionText(false);
                          setRejectionMessage("");
                          setKycError(false);
                          setKycCompleted(false);

                          props.setCustomLoading(false);
                        } else {
                          errorToast(
                            "Oops something went wrong",
                            "Unable to update your previous KYC submission. Try again later",
                          );
                          props.setCustomLoading(false);
                        }
                      }
                    }}
                    className="verify-kyc-button-back"
                  >
                    <p className="verify-kyc-button-back-text">Fix Rejection</p>
                  </button>
                )}
                <button
                  onClick={() => {
                    props.setShowPopup(false);
                    props.setPopupContent(null);
                    props.setPopupContentPosition("center");
                    setShowSumsubPortal(false);
                    setKycCompleted(false);
                    navigate("/");
                  }}
                  className="verify-kyc-button"
                >
                  <p className="verify-kyc-button-text">Close</p>
                </button>
              </>
            )}
            {rejectionMessage === "" && (
              <button
                style={{ marginTop: "24px" }}
                onClick={() => {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  props.setPopupContentPosition("center");
                  setShowSumsubPortal(false);
                  setKycCompleted(false);
                  navigate("/");
                }}
                className="verify-kyc-button"
              >
                <p className="verify-kyc-button-text">Close</p>
              </button>
            )}
          </>
        )}
        {showSumsubPortal && kycError && (
          <button
            style={{ marginTop: "24px" }}
            onClick={() => {
              props.setShowPopup(false);
              props.setPopupContent(null);
              props.setPopupContentPosition("center");
              setShowSumsubPortal(false);
              setKycError(false);
              navigate("/");
            }}
            className="verify-kyc-button"
          >
            <p className="verify-kyc-button-text">Close</p>
          </button>
        )}
        {showSumsubPortal &&
          !kycCompleted &&
          !kycError &&
          linkToUse?.length > 0 && (
            <button
              style={{ marginTop: "24px", marginBottom: "30px" }}
              onClick={() => {
                props.setShowPopup(false);
                props.setPopupContent(null);
                props.setPopupContentPosition("center");
                setShowSumsubPortal(false);
                setKycError(false);
                setLinkToUse("");
                navigate("/");
              }}
              className="verify-kyc-button"
            >
              <p className="verify-kyc-button-text">Close</p>
            </button>
          )}
      </div>
    </div>
  );
};

export default VerifyKYC;
